module.exports = __webpack_public_path__ + "static/media/ret-enter-icon.ec3bb571.svg";